/**
 * @desc: BarChart 柱状图组件演示文件
 */
import React, { useState } from 'react';
import BarChart from './index';

const MOCK_DATA: IBarChartData[] = [
  { name: 'Game A', value: 320 },
  { name: 'Game B', value: 280 },
  { name: 'Game C', value: 450 },
  { name: 'Game D', value: 190 },
  { name: 'Game E', value: 500 },
];

const MOCK_DATA_MANY: IBarChartData[] = [
  { name: 'Product 1', value: 820 },
  { name: 'Product 2', value: 932 },
  { name: 'Product 3', value: 901 },
  { name: 'Product 4', value: 934 },
  { name: 'Product 5', value: 1290 },
  { name: 'Product 6', value: 1330 },
  { name: 'Product 7', value: 1320 },
  { name: 'Product 8', value: 1100 },
  { name: 'Product 9', value: 980 },
  { name: 'Product 10', value: 870 },
];

const BasicDemo: React.FC = () => {
  return (
    <div style={{ width: 600, height: 400 }}>
      <BarChart
        data={MOCK_DATA}
        loading={false}
        metricName="Revenue"
        useXAxisLabelRotate
      />
    </div>
  );
};

const HighlightDemo: React.FC = () => {
  return (
    <div style={{ width: 600, height: 400 }}>
      <BarChart
        data={MOCK_DATA}
        loading={false}
        metricName="Downloads"
        highlightName="Game C"
      />
    </div>
  );
};

const ClickDemo: React.FC = () => {
  const [clickInfo, setClickInfo] = useState<string>('点击柱子查看数据');

  const handleBarClick = (params: IBarChartClickParams) => {
    setClickInfo(
      `点击了: ${params.name}, 值: ${params.value}, 索引: ${params.dataIndex}`,
    );
  };

  return (
    <div>
      <div style={{ marginBottom: 12, fontSize: 14, color: '#333' }}>
        {clickInfo}
      </div>
      <div style={{ width: 600, height: 400 }}>
        <BarChart
          data={MOCK_DATA_MANY}
          loading={false}
          metricName="Revenue"
          onBarClick={handleBarClick}
          useXAxisLabelRotate
        />
      </div>
    </div>
  );
};

/**
 * Demo 案例配置
 */
export const demoConfig = [
  {
    title: '基础用法',
    description:
      '传入最基础的 name/value 数据，loading 设为 false 后图表自动渲染',
    code: `const data = [
  { name: 'Game A', value: 320 },
  { name: 'Game B', value: 280 },
  { name: 'Game C', value: 450 },
  { name: 'Game D', value: 190 },
  { name: 'Game E', value: 500 },
];

<BarChart
  data={data}
  loading={false}
  metricName="Revenue"
  useXAxisLabelRotate
/>`,
    element: <BasicDemo />,
  },
  {
    title: '高亮数据项',
    description:
      '通过 highlightName 指定高亮的数据项名称，该数据项会以高亮背景和加粗标签展示',
    code: `const data = [
  { name: 'Game A', value: 320 },
  { name: 'Game B', value: 280 },
  { name: 'Game C', value: 450 },
  { name: 'Game D', value: 190 },
  { name: 'Game E', value: 500 },
];

<BarChart
  data={data}
  loading={false}
  metricName="Downloads"
  highlightName="Game C"
/>`,
    element: <HighlightDemo />,
  },
  {
    title: '点击事件',
    description: '通过 onBarClick 监听柱子点击事件，可获取点击的数据项信息',
    code: `const handleBarClick = (params: IBarChartClickParams) => {
  console.debug('点击了:', params.name, params.value);
};

<BarChart
  data={data}
  loading={false}
  metricName="Revenue"
  onBarClick={handleBarClick}
  useXAxisLabelRotate
/>`,
    element: <ClickDemo />,
  },
];

export default demoConfig;
